module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card who",
    attrs: {
      "id": "who"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fetch card-content",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [(_vm.hasResults) ? _c('table', {
    staticClass: "yellow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.who), function(value, index) {
    return _c('tr', [_c('td', [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(_vm.labels[index].icon))]), _vm._v(" " + _vm._s(value !== 1 ? _vm.labels[index].plural : _vm.labels[index].singular))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(value).toLocaleString('en-US')))])])
  }), 0)]) : _c('div', [_c('p', [_vm._v("No results that match those filters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-wrap center",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "card-h2"
  }, [_c('span', [_vm._v("Who")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Metric")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40c2a2d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/collisions/Who.vue
// module id = 430
// module chunks = 1